import type { NodeData } from "@/workflow_api/types/workflow";
import type { TimeValuesConfig, TimerUnit } from "../types";
import { isValidField } from "./index";

export const getDeserializedTimerInputs = (
  node?: NodeData,
): {
  internalData?: TimeValuesConfig;
  externalData?: TimeValuesConfig;
} => {
  const inputs = node?.inputs || [];
  if (!inputs.length) return {};
  // Extract internal data
  const internalData: Partial<TimeValuesConfig> = {};
  const internalMaxUnit = inputs.find(
    (input) => input.name === "internal_max_unit",
  );
  if (internalMaxUnit) {
    internalData.limit_unit = internalMaxUnit.value as TimerUnit;
  }
  const internalMaxAmount = inputs.find(
    (input) => input.name === "internal_max_amount",
  );
  if (internalMaxAmount) {
    internalData.limit_amount = internalMaxAmount.value as number;
  }
  const internalMaxPreventions = inputs.find(
    (input) => input.name === "internal_max_preventions",
  );
  if (internalMaxPreventions) {
    internalData.limit_preventions = internalMaxPreventions.value as number;
  }

  // Extract external data
  const externalData: Partial<TimeValuesConfig> = {};
  const externalMaxUnit = inputs.find(
    (input) => input.name === "external_max_unit",
  );
  if (externalMaxUnit) {
    externalData.limit_unit = externalMaxUnit.value as TimerUnit;
  }
  const externalMaxAmount = inputs.find(
    (input) => input.name === "external_max_amount",
  );
  if (externalMaxAmount) {
    externalData.limit_amount = externalMaxAmount.value as number;
  }
  const externalMaxPreventions = inputs.find(
    (input) => input.name === "external_max_preventions",
  );
  if (externalMaxPreventions) {
    externalData.limit_preventions = externalMaxPreventions.value as number;
  }

  const consumeGlobalPreventions = inputs.find(
    (input) => input.name === "consume_global_preventions",
  );
  if (consumeGlobalPreventions) {
    externalData.global_preventions = consumeGlobalPreventions.value as boolean;
  }

  // Check if objects have all required fields before returning using isValidField
  const hasAllInternalFields =
    isValidField(internalData.limit_unit) &&
    isValidField(internalData.limit_amount);

  const hasAllExternalFields =
    isValidField(externalData.limit_unit) &&
    isValidField(externalData.limit_amount);

  return {
    internalData: hasAllInternalFields
      ? (internalData as TimeValuesConfig)
      : undefined,
    externalData: hasAllExternalFields
      ? (externalData as TimeValuesConfig)
      : undefined,
  };
};
